import { atom, useSetAtom } from 'jotai';
import { useEffect } from 'react';

export const AppHeightAtom = atom<{ mode: 'hidden' | 'auto'; paddingBottom?: number }>({
  mode: 'auto',
});

type FixAppHeightProps = {
  /**
   * Optional padding bottom to apply when height is set to hidden, to avoid cutting content off
   */
  pb?: number;
};

/**
 * Add this component to a page in order to set the main content to 100vh with no overflow scroll.
 * This is meant for pages where we want an internal component to handle the scroll without shifting the whole page.
 */
export const FixAppHeight = ({ pb }: FixAppHeightProps) => {
  const setAppHeight = useSetAtom(AppHeightAtom);

  useEffect(() => {
    setAppHeight({ mode: 'hidden', paddingBottom: pb });
    return () => setAppHeight({ mode: 'auto' });
  }, [setAppHeight, pb]);

  return null;
};
